import React from 'react';

import { Value } from './Content.jsx';
import Token from '../utility/Token.jsx';
import _TypeConfig from './TypeConfig.jsx';

// #region META

function _Meta(props) { return <Value {...props} value={props.content} /> }
const Meta = Token.withContentTokenParsing(_Meta, {}, Token.TypeParsing.inventory);
const TypeConfig = {
    defaultDesign: `<p><span token="${Token.Artist.Name}">{${Token.Artist.Name}("before":"","after":"")}</span></p><p><span style="display:inline;font-style:italic;" token="${Token.Inventory.Title}">{${Token.Inventory.Title}("before":"","after":"")}</span><span style="display:inline;" token="${Token.Inventory.Edition}">{${Token.Inventory.Edition}("before":" (","after":")")}</span><span style="display:inline;" token="${Token.Date}">{${Token.Date}("before":", ","after":"")}</span></p><p><span token="${Token.Inventory.Medium}">{${Token.Inventory.Medium}("before":"","after":"")}</span></p><p><span token="${Token.Inventory.Dimensions}">{${Token.Inventory.Dimensions}("before":"","after":"")}</span></p><p><span token="${Token.Inventory.AlternateDimensions}">{${Token.Inventory.AlternateDimensions}("before":"","after":"")}</span><p><span token="${Token.Inventory.SKU}">{${Token.Inventory.SKU}("before":"SKU: ","after":"")}</span></p><p><span token="${Token.Inventory.Number}">{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}</span></p>`,
    panel: {
        block: (design) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Design item meta here',
                        label: 'Item Meta Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: design || TypeConfig.defaultDesign
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout')
    }
};

// #endregion META

export {
    Meta as Component,
    TypeConfig
}